

(function($) {
    function onElementMutated(p_options) {
      var observer = new MutationObserver(function(mutations) {
        p_options.callback(mutations);
      });
      var observerConfig = {
        attributes: true, 
        childList: true, 
        characterData: false 
      };
      var targetNodes = document.querySelectorAll(p_options.selector);
      targetNodes.forEach(function(node) {
        observer.observe(node, observerConfig);
      });  
    };  
    
    function getCartData() {
      return new Promise(function(resolve, reject) {
        $.getJSON('/cart.js', function(cart) {
          resolve(cart);
        });
      });
    }
    
    var progressBars = [];
    var selectors = {
      containers: {
        shippingProgress: '.shipping-progress',
        shippingProgressBar: '.shipping-progress .bar',
        shippingProgressMessage: '.shipping-progress .message'
      }
    };
    
    var shippingBar = {
      init: function() {
        // Append message and progressbar markup
        $(selectors.containers.shippingProgress).each(function() {
          $(this).html('<span class="message"></span><div class="bar"></div>');
        });
        
        // Initialize progress bar
        $(selectors.containers.shippingProgress).each(function() {
          var $bar = $(this).find('.bar')[0];
          var progressbar = new ProgressBar.Line($bar, shippingProgressBarSettings.progressBarOptions);
          progressBars.push(progressbar);
        });
      },
      update: function() {
        getCartData()
        .then(function(cart) {
          progressBars.forEach(function(progressbar) {
            progressbar.animate((progress < 1) ? progress : 1);
          });
        });
      }
    }
    
    function updateShippingProgress(cart) {
      var progress = cart.total_price / shippingProgressBarSettings.minCartAmount;
    }
    
    $(function() {
      // On document ready, update shipping bar
      shippingBar.init();
      shippingBar.update();
      
      // On Cart updated, update shipping bar
      onElementMutated({
        selector: '.bigcounter',
        callback: shippingBar.update
      });
    });
  
  })(jQuery);

  function toggleBodyOverflow() {
    const cartDrawer = document.querySelector('cart-drawer');
    const body = document.body;

    if (cartDrawer.classList.contains('active')) {
        body.style.overflow = 'hidden';
    } else {
        body.style.overflow = '';
    }
}
// Set item variants in cart drawer to capital case
const observer = new MutationObserver(toggleBodyOverflow);
observer.observe(document.querySelector('cart-drawer'), { attributes: true, attributeFilter: ['class'] });

// Initial check in case the cart drawer is already open on page load
toggleBodyOverflow();
  // Open megamenu elements on hover
const megaMenuElements = document.querySelectorAll('.mega-menu');
megaMenuElements.forEach((element) => {
  element.addEventListener('mouseenter', () => {
    element.setAttribute('open', '');
  });
  element.addEventListener('mouseleave', () => {
    element.removeAttribute('open');
  });
});

// Classlist toggle on hamburger click 
document.addEventListener('DOMContentLoaded', function () {
document.querySelector('.header__icon--summary').addEventListener('click', function() {
  this.classList.toggle('menu-open');
});
});


// Reusable function to capitalize variants
function capitalizeCartVariants() {
  document.querySelectorAll('.cart-item__variant').forEach(function(element) {
    element.textContent = element.textContent
      .toLowerCase()
      .replace(/(^|\s)\S/g, function(letter) {
        return letter.toUpperCase();
      });
  });
}

// Run the function on page load
document.addEventListener("DOMContentLoaded", function() {
  capitalizeCartVariants();
});



document.addEventListener('DOMContentLoaded', function () {
  // Get all footer headers
  var headers = document.querySelectorAll('.footer-block__header');

  headers.forEach(function(header) {
    header.addEventListener('click', function() {
      // Toggle the active class on the parent div
      var parentBlock = header.parentElement;
      parentBlock.classList.toggle('footer-block--active');
    });
  });
});
document.addEventListener("DOMContentLoaded", function() {
  const bodyElement = document.querySelector('body');
  const currentURL = window.location.href;
  if (currentURL.includes("/fr/")) {
      bodyElement.classList.remove('en')
      bodyElement.classList.add('fr')
  } else {
    bodyElement.classList.remove('fr')
    bodyElement.classList.add('en')
  }
  if (currentURL.includes('return-refund-policy')){
      bodyElement.classList.add('return-refund-policy');
  }
  if (currentURL.includes('return-form')){
      bodyElement.classList.add('return-form');
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const currentUrl = window.location.href;
const body = document.querySelector('body');

if (currentUrl.includes('contact')) {
  body.classList.add('contact-page');
  
}

if (currentUrl.includes('return-form')) {
  body.classList.add('return-form-page');    
}
if (currentUrl.includes('return-policy')) {
  body.classList.add('return-policy');    
}
if (currentUrl === `https://www.us.kamik.com` || currentUrl === `https://www.us.kamik.com/` || currentUrl ===  `https://us.kamik.com` || currentUrl === `https://us.kamik.com/`) {
  body.classList.add('homepage');
}
if (currentUrl.includes('shipping')) {
  body.classList.add('shipping');    
}
if (currentUrl.includes('accessibility')) {
  body.classList.add('accessibility');    
}
if (currentUrl.includes('careers')) {
  body.classList.add('careers');    
}
if (currentUrl.includes('warranty')) {
  body.classList.add('warranty');    
}
if (currentUrl.includes('faq')) {
  body.classList.add('faq');    
}
  if (currentUrl.includes('collections')) {
  body.classList.add('collection-page');
};
if (currentUrl.includes('return-instructions')) {
  body.classList.add('return-instructions');    
};
    if (currentUrl.includes('/products/')) {
  body.classList.add('product-page');
};
});

window.addEventListener('scroll', function() {
  if (window.scrollY > 100) {
    document.body.classList.add('scrolled');
  } else {
    document.body.classList.remove('scrolled');
  }
});


document.addEventListener('DOMContentLoaded', function () {
  if (window.location.href.includes('contact')) {
    var typeOfDemandDropdown = document.getElementById('type_of_demand');
    var conditionalFields = [
      'image_of_defect',
      'image_of_boots',
      'style_name_or_number',
      'order_number',
      'size',
      'color',
      'shipping_address'
    ];
    var conditionalNonRequired = [
      'retailer_name',
      'purchase_date'
    ]

    function toggleFields() {
      var selectedValue = typeOfDemandDropdown.value;
      var shouldShowFields = (selectedValue === 'Defective product' || selectedValue === 'Defective Apparel Product');
      
      // Show or hide each field and toggle 'required' attribute
      conditionalFields.forEach(function (fieldId) {
        var field = document.getElementById(fieldId);
        var formGroup = field.closest('.form-group');
        
        if (shouldShowFields) {
          formGroup.style.display = 'block';
          field.setAttribute('required', 'required');
        } else {
          formGroup.style.display = 'none';
          field.removeAttribute('required');
        }
      });

      conditionalNonRequired.forEach(function (fieldId) {
        var field = document.getElementById(fieldId);
        var formGroup = field.closest('.form-group');
        
        if (shouldShowFields) {
          formGroup.style.display = 'block';
        } else {
          formGroup.style.display = 'none';
        }
      });
    }

    typeOfDemandDropdown.addEventListener('change', toggleFields);
    toggleFields();
  }



  function showDescriptionField() {
    if (window.location.href.includes('return-form')) {
      const returnReason = document.getElementById('return_reason');
      const describeText = document.getElementById('describeText');
      const descriptionText = document.getElementById('description_text');
      returnReason.addEventListener('change', function() {
        const selectedOption = returnReason.options[returnReason.selectedIndex].value;

        if (selectedOption === 'Other (Please describe)' || selectedOption === 'Product differs from Website (Please describe)') {
          describeText.style.display = 'block';
          descriptionText.setAttribute('required', true);
        } else {
          describeText.style.display = 'none';
          descriptionText.removeAttribute('required');
        }
      });
    }
  }

  showDescriptionField();
});

document.addEventListener('DOMContentLoaded', function() {
  const product = window.product;
  
  // Function to check and log the available stock for each size variant
  function checkStockForSelectedColor() {
    const selectedColor = document.querySelector('input[name="Color"]:checked').value; // Get the currently selected color
    console.log(`Selected Color: ${selectedColor}`);
    
    // Loop through each variant to find the ones that match the selected color
    product.variants.forEach((variant) => {
      const colorName = variant.option1; // Assuming option1 is color
      const sizeName = variant.option2; // Assuming option2 is size
      const available = variant.available;

      // If the variant's color matches the selected color, check stock status for sizes
      if (colorName === selectedColor) {
        console.log(`  Size: ${sizeName}, Available: ${available ? 'In stock' : 'Out of stock'}`);
        
        // Find the corresponding size element and add the appropriate class
        const sizeElement = document.querySelector(`input[name="Size"][value="${sizeName}"]`);
        
        if (sizeElement) {
          // Add the 'in-stock' or 'out-of-stock' class to the size element
          if (available) {
            sizeElement.closest('.swatch-element').classList.add('in-stock');
            sizeElement.closest('.swatch-element').classList.remove('out-of-stock');
          } else {
            sizeElement.closest('.swatch-element').classList.add('out-of-stock');
            sizeElement.closest('.swatch-element').classList.remove('in-stock');
          }
        }
      }
    });
  }

  // Run the function on page load
  checkStockForSelectedColor();

  // Listen for clicks on color swatches and re-check stock for the newly selected color
  const colorVariants = document.querySelectorAll('input[name="Color"]');
  colorVariants.forEach((colorVariant) => {
    colorVariant.addEventListener('change', function() {
      checkStockForSelectedColor(); // Re-check stock on color change
    });
  });
});

document.addEventListener('DOMContentLoaded', function(){
  const priceAndPillWrapper = document.querySelector('.product .product__info-wrapper .product__title.product__title-price div.no-js-hidden');
  if (priceAndPillWrapper) {
    const pills = priceAndPillWrapper.querySelector('.product__breadcrumb-tags-list');
    if (pills.children.length > 1) {
      priceAndPillWrapper.classList.add('multiple-pills');
    }
  }
});


document.addEventListener('DOMContentLoaded', () => {
    document.addEventListener('click', (event) => {
        if (event.target.matches('input.mobile-facets__checkbox')) {
            document.body.classList.remove('overflow-hidden-mobile');
        }
    });

    document.addEventListener('touchstart', (event) => {
        if (event.target.matches('input.mobile-facets__checkbox')) {
            document.body.classList.remove('overflow-hidden-mobile');
        }
    });
});



